<template>
	<div id="app">
		<!-- <keep-alive exclude=""> -->
			<router-view v-if="!platform_pc"></router-view>
			<template v-if="platform_pc">
				<keep-alive exclude="news-info,product-info,products,watch-list">
					<router-view></router-view>
				</keep-alive>
			</template>
		<!-- </keep-alive> -->
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {},
	data: function () {
		return {
			platform_pc: null,  //pc
		}
	},
	created(){
		let isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
		if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|Huawei|HONOR|OpenHarmony|HarmonyOS/i.test(navigator.userAgent) || isiPad) {
			this.platform_pc = true;
		}else {
			this.platform_pc = false;
		}
	},
	mounted() {
		//
	}
}
</script>
<style>
@charset "utf-8";
@font-face {
	font-family: 'PFFont';
	src: url('./assets/fonts/PingFang Medium.ttf');
}
@font-face {
	font-family: 'Light';
	src: url('./assets/fonts/Varta-Light.ttf');
}
@font-face {
	font-family: 'Medium';
	src: url('./assets/fonts/Varta-Medium.ttf');
}
@font-face {
	font-family: 'Regular';
	src: url('./assets/fonts/Varta-Regular.ttf');
}
::-webkit-input-placeholder{color:#999999;}
/* ::-webkit-scrollbar{display:none;width:0 !important;height:0 !important;-webkit-appearance:none;background:transparent;} */
*{/* margin:0;padding:0; */font-family: "Medium", "Helvetica", 'Arial';outline:none;text-decoration:none;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);touch-action: pan-y;
word-wrap: normal;letter-spacing: 0px;word-break: normal;line-height: 1.6;}
img{vertical-align:top;}
html,body{
	width:100%;height:100%;margin:0px;padding:0px;-webkit-overflow-scrolling: touch;
	-webkit-text-size-adjust: 100% !important;
}
input,div,span,select,textarea,button{}
input{-webkit-appearance: none;}
.font-b{font-weight:bold;}
/* .banner_box img{
	min-width: 1308px !important;
}
.main_box{
	min-width: 1308px;
} */

.el-popconfirm .el-button--primary:hover{
	background-color: rgba(0, 107, 179, 0.9);
	border-color: rgba(0, 107, 179, 0.9)
}
.el-popconfirm .el-button--primary{
	background-color: rgb(0, 107, 179);
	border-color: rgb(0, 107, 179);
}
.el-popconfirm .el-button--text:hover{
	color: rgba(0, 107, 179, 0.9);
}
.el-popconfirm .el-button--text{
	color: rgb(0, 107, 179);
}
.el-message-box__wrapper .el-button--primary{
	background-color: rgb(0, 107, 179) !important;
	border-color: rgb(0, 107, 179) !important;
}
.el-message-box__wrapper .el-button--primary:hover{
	background-color: rgb(0, 107, 179) !important;
	color: #ffffff !important;
}
.el-message-box__wrapper .el-button:hover{
	background-color: rgba(0, 107, 179, 0.1);
	color: rgb(0, 107, 179);
}

.van-checkbox__icon .van-icon{
	border: 2px solid #c8c9cc;
}

input[aria-hidden=true] {
	display: none !important;
}

.loading{width:100%;height:100%;position:fixed;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}
</style>